import {registerTileSchema} from '#core/application/schema-registry.js';

import PRICE_CHANGE_INDICATOR from './price-change-indicator.palette-schema.yaml';

registerTileSchema(PRICE_CHANGE_INDICATOR);

export function generatePriceChangeIndicator(TILE) {
    return {
        arrowheadDown: {
            style: {
                backgroundColor: TILE.PRICE_CHANGE_INDICATOR_DOWN_COLOR,
            },
            size: TILE.PRICE_CHANGE_INDICATOR_SIZE,
        },
        arrowheadUp: {
            style: {
                backgroundColor: TILE.PRICE_CHANGE_INDICATOR_UP_COLOR,
            },
            size: TILE.PRICE_CHANGE_INDICATOR_SIZE,
        },
    };
}
